import Keys from "../classes/Keys";

const defaultState = () => ({
  data: []
});

const state = defaultState();

const getters = {};

const actions = {
  resetState(state) {
    Object.assign(state, defaultState());
  },
  keys_list(state, data) {
    state.commit("setData", data);
  }
};

const mutations = {
  setData(state, data) {
    state.data = Keys.getSelfList(data);
  },
  addFirst(state) {
    state.data.unshift(new Keys());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
